import { CLIENT_ID, ISSUER, OKTA_TESTING_DISABLEHTTPSCHECK } from "./creds";

const REDIRECT_URI = `${window?.location?.origin}/callback`;
export const REDIRECT_LOGOUT_URI = `${window?.location?.origin}/logout-successful`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    responseMode: "fragment",
    tokenManager: {
      storage: "cookie",
    },
    scopes: [
      "openid",
      "profile",
      "email",
      // 'groups',
      //'offline_access',
      // 'UserID',
    ],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
};

export const SESSION_IDLE_TIMEOUT = 1000 * 60 * 15; // With in how many milliseconds app has to show Logout Alert
export const SESSION_IDLE_LOGOUT = 1000 * 60 * 2; // After Alert is shown, with in how may milliseconds app has to logout
export const SESSION_TIMER_MINUTES = Math.floor(SESSION_IDLE_LOGOUT / 60000);
export const SESSION_TIMER_SECONDS = (SESSION_IDLE_LOGOUT % 60000) / 1000;

// import { getCookies } from './utils/cookies';

// export const getConfig = () => {
//   const { CLIENT_ID, ISSUER, OKTA_TESTING_DISABLEHTTPSCHECK } = getCookies([
//     'CLIENT_ID',
//     'ISSUER',
//     'OKTA_TESTING_DISABLEHTTPSCHECK',
//   ]);
//   return {
//     oidc: {
//       clientId: CLIENT_ID,
//       issuer: ISSUER,
//       redirectUri: REDIRECT_URI,
//       responseMode: 'fragment',
//       tokenManager: {
//         storage: 'cookie',
//       },
//       scopes: [
//         'openid',
//         'profile',
//         'email',
//         // 'groups',
//         'offline_access',
//         // 'UserID',
//       ],
//       pkce: true,
//       disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
//     },
//   };
// };
